import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
    forms: {
        'technology-media': [],
        'technology-pixel': []
    },
    showFormTransfer: false,
    showFormCreateTransfer: false,
    transferInEdition: {},
    isEdit: false,
    endDate: null,
    activeTransfers: 0,
    selectedTransferRowId: null,
    displayModal: {
        transfer: false,
        bulkEdit: false
    },
    deletedTransfer: {
        transferId: null,
        audienceId: null
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
